export interface AvatarColor {
  "background-color": string;
  color: string;
}

export const AVATAR_COLORS_BRIGHT: AvatarColor[] = [
  { "background-color": "#FDE68A", color: "#92400E" }, // amarillo cálido
  { "background-color": "#A7F3D0", color: "#065F46" }, // verde menta
  { "background-color": "#BFDBFE", color: "#1E3A8A" }, // azul pastel
  { "background-color": "#FBCFE8", color: "#9D174D" }, // rosa suave
  { "background-color": "#DDD6FE", color: "#5B21B6" }, // morado lavanda
  { "background-color": "#FCA5A5", color: "#7F1D1D" }, // coral
  { "background-color": "#BAE6FD", color: "#075985" }, // celeste
  { "background-color": "#BBF7D0", color: "#14532D" }, // verde claro
  { "background-color": "#FDE2E2", color: "#7F1D1D" }, // rosado crema
  { "background-color": "#E9D5FF", color: "#581C87" }, // púrpura pastel
  { "background-color": "#FBCFE8", color: "#9D174D" }, // rosado fuerte
  { "background-color": "#D1FAE5", color: "#064E3B" }, // verde agua
  { "background-color": "#FECACA", color: "#7F1D1D" }, // rojo suave
  { "background-color": "#E0F2FE", color: "#1E40AF" }, // azul cielo
  { "background-color": "#FEF3C7", color: "#92400E" }, // amarillo pastel
  { "background-color": "#C7D2FE", color: "#3730A3" }, // azul violeta
  { "background-color": "#F9A8D4", color: "#831843" }, // fucsia suave
  { "background-color": "#86EFAC", color: "#065F46" }, // verde brillante
  { "background-color": "#FCD34D", color: "#78350F" }, // mostaza
  { "background-color": "#93C5FD", color: "#1E3A8A" }, // azul vibrante
];

export const AVATAR_COLORS_SOFT: AvatarColor[] = [
  { "background-color": "#E6D9FF", color: "#4B2E83" }, // lila suave
  { "background-color": "#D4E3FF", color: "#1E3A8A" }, // azul claro opaco
  { "background-color": "#FFE5E0", color: "#7F1D1D" }, // coral apagado
  { "background-color": "#E2F7F2", color: "#065F46" }, // verde agua opaco
  { "background-color": "#FFF2CC", color: "#92400E" }, // amarillo crema
  { "background-color": "#EADFF2", color: "#5B21B6" }, // lavanda grisáceo
  { "background-color": "#D9F0E6", color: "#14532D" }, // verde bosque suave
  { "background-color": "#F8D7DA", color: "#7A1C2C" }, // rosado tenue
  { "background-color": "#D6E4FF", color: "#274690" }, // azul medio
  { "background-color": "#FFE8D6", color: "#78350F" }, // naranja claro opaco
  { "background-color": "#E3E8FF", color: "#3730A3" }, // azul violáceo suave
  { "background-color": "#FFDDE2", color: "#831843" }, // rosado oscuro apagado
  { "background-color": "#E0F5FF", color: "#075985" }, // celeste opaco
  { "background-color": "#F6E6B8", color: "#7C2D12" }, // mostaza suave
  { "background-color": "#E8F7DA", color: "#365314" }, // verde oliva claro
  { "background-color": "#F1E0E9", color: "#701A75" }, // púrpura suave
  { "background-color": "#E0F2EE", color: "#134E4A" }, // verde jade apagado
  { "background-color": "#FFEADB", color: "#9A3412" }, // durazno suave
  { "background-color": "#DFECF2", color: "#1E40AF" }, // azul acero
  { "background-color": "#F3E8E2", color: "#78344C" }, // rosa polvo opaco
];

